import { z } from "zod";
import { COST_CALCULATION_TYPE } from "@miplatform/constants";

export const addItemsSchema = z
  .object({
    id: z.string(),
    category: z.object({
      categoryName: z.string(),
      categoryId: z.string(),
    }),
    attributes: z.array(
      z
        .object({
          attributeId: z.string().optional(),
          value: z.string().optional().default(""),
          isRequired: z.boolean().optional(),
        })
        .superRefine((attr, ctx) => {
          if (attr.isRequired && !attr.value) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: "This attribute is required",
              path: ["value"],
            });
          }
        })
    ),
    manufacturerPartNumber: z
      .string()
      .min(1, "Manufacturer Part Number is required"),
    manufacturerDescription: z
      .string()
      .min(1, "Manufacturer Description is required"),
    fieldNote: z.string().optional(),
    costCalculation: z.enum([
      COST_CALCULATION_TYPE.COST_PLUS,
      COST_CALCULATION_TYPE.LIST_DOWN,
    ]),
    manufacturerListPrice: z
      .union([
        z
          .string()
          .refine((val) => val.trim() !== "", {
            message: "List Price must be greater than $0.00",
          })
          .transform((x) => x.replace(/[^0-9.-]+/g, "")),
        z.number(),
      ])
      .pipe(
        z.coerce
          .number({ required_error: "List Price is required" })
          .min(0.01)
          .max(99999.99, "List Price must be less than $100,000.00")
      ),
    multiplier: z.number().optional(),
    taxRate: z.number().min(0.01, "Tax Rate is required"),
  })
  .refine(
    (data) => {
      // If Cost Calculation is List Down, Multiplier is required
      if (
        data.costCalculation === COST_CALCULATION_TYPE.LIST_DOWN &&
        !data.multiplier
      ) {
        return false;
      }
      return true;
    },
    {
      message: "Multiplier is required",
      path: ["multiplier"],
    }
  );
